var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3201 7.59092C13.108 7.37878 12.8505 7.27279 12.5473 7.27279H12.1839V5.09085C12.1839 3.69693 11.684 2.50007 10.684 1.50007C9.68402 0.500022 8.48727 0 7.09316 0C5.69908 0 4.5021 0.500022 3.50221 1.50003C2.50217 2.50007 2.00231 3.69689 2.00231 5.09085V7.27279H1.63872C1.3358 7.27279 1.07816 7.37878 0.866022 7.59092C0.653882 7.8029 0.547852 8.06054 0.547852 8.36374V14.9091C0.547852 15.2121 0.653922 15.4698 0.866022 15.6819C1.07816 15.8939 1.3358 16 1.63872 16H12.5476C12.8508 16 13.1082 15.894 13.3204 15.6819C13.5324 15.4698 13.6386 15.2121 13.6386 14.9091V8.36362C13.6387 8.06066 13.5324 7.80306 13.3201 7.59092ZM10.0022 7.27279H4.18413V5.09085C4.18413 4.28786 4.46827 3.60221 5.03643 3.03412C5.60467 2.46596 6.29021 2.18194 7.09328 2.18194C7.89643 2.18194 8.5818 2.46592 9.15008 3.03412C9.71809 3.60217 10.0022 4.28786 10.0022 5.09085V7.27279Z",
    fill: "#6B6B76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.dc4d0727.svg";
export { ForwardRef as ReactComponent };